import {ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {NavDropdownItem} from './nav-dropdown.model';

@Component({
    selector: 'ui-nav-dropdown',
    templateUrl: './nav-dropdown.component.html',
    styleUrls: ['./nav-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class NavDropdownComponent implements OnChanges, OnDestroy {

    @Input() public itens: NavDropdownItem[];
    @Input() public selecionada?: NavDropdownItem;

    private itensSubject = new BehaviorSubject<NavDropdownItem[]>([]);
    private filtroSubject = new BehaviorSubject<string>('');

    public itensFiltrados$: Observable<NavDropdownItem[]> = combineLatest([
        this.itensSubject,
        this.filtroSubject
    ]).pipe(
        map(([itens, filtro]) => {
            const termo = (filtro || '').trim().toLowerCase();
            return termo
                ? itens.filter(item => item.nome.toLowerCase().includes(termo))
                : itens;
        })
    );

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.itens) {
            this.itensSubject.next(this.itens || []);
        }
    }

    ngOnDestroy(): void {
        this.itensSubject.complete();
        this.filtroSubject.complete();
    }

    public filtrar = (filtro: string) => this.filtroSubject.next(filtro);

    public selecionar = (item: NavDropdownItem) => item.acao();

    public naoFecharMenu = (e: any) => e.stopPropagation();

}